<template>
  <div></div>
</template>

<script>
export default {
  props: [
    'appName'
  ],
  mounted () {
    this.$gtag.pageview(window.location.pathname)
  }
}
</script>
